import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=388d0e7e&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('388d0e7e')) {
      api.createRecord('388d0e7e', component.options)
    } else {
      api.reload('388d0e7e', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=388d0e7e&", function () {
      api.rerender('388d0e7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24K9VcD1MHU5H/JS/comp/ErrorMessage.vue"
export default component.exports